import clsx from "clsx";
import { HalfFormRowRoot } from "./HalfFormRow.styles";
import { Row } from "@commonlibs";

export interface HalfFormRowProps {
    className?: string;
    style?: React.CSSProperties;
    children: [React.ReactNode, React.ReactNode];
}

function HalfFormRow({ className, children, ...rest }: HalfFormRowProps) {
    return (
        <HalfFormRowRoot className={clsx("half-form-row", className)} justifyContent="space-between" {...rest}>
            <Row className="half-row" justifyContent="flex-start">
                {children[0]}
            </Row>
            <Row className="half-row">{children[1]}</Row>
        </HalfFormRowRoot>
    );
}

export default HalfFormRow;
